
  <!-- used to trick browsers into autofilling these inputs instead of the actual username and password inputs -->
  <input
  style="display: none"
  type="password"
  name="password"
  autocomplete="password"
  />
  <input
  style="display: none"
  type="password"
  name="old password"
  autocomplete="password"
  />
  <input
  style="display: none"
  type="password"
  name="password"
  autocomplete="new-password"
  />
<div id="login-page" class="primary-background">
  <div id="login-form">
    <nb-card>
      <nb-card-body>
        <h1 class="align-center">{{'reset'| translation}} {{'password'| translation}}</h1>
        <div *ngIf="policies != null;else loading">
          <div class="align-center">
            <div>
              <p>{{'requirements'| translation}}: </p>
              <p *ngIf="policies?.MinimumLength > 0" [ngClass]="{'strike-through' : newPassword.dirty && (!newPassword.errors || !newPassword.errors.minlength)}">{{'requirement_minimum_length'| translation}}: {{policies.MinimumLength}}</p>
              <p *ngIf="policies?.RequireUppercase" [ngClass]="{'strike-through' : newPassword.dirty && (!newPassword.errors || !newPassword.errors.mustHaveUpercase)}">{{'requirement_uppercase'| translation}}</p>
              <p *ngIf="policies?.RequireLowercase" [ngClass]="{'strike-through' : newPassword.dirty && (!newPassword.errors || !newPassword.errors.mustHaveLowercase)}">{{'requirement_lowercase'| translation}}</p>
              <p *ngIf="policies?.RequireNumbers" [ngClass]="{'strike-through' : newPassword.dirty && (!newPassword.errors || !newPassword.errors.mustHaveNumber)}">{{'requirement_number'| translation}}</p>
              <p *ngIf="policies?.RequireSymbols" [ngClass]="{'strike-through' : newPassword.dirty && (!newPassword.errors || !newPassword.errors.mustHaveSpecialCharacter)}">{{'requirement_special_character'| translation}}</p>
            </div>
          </div>
          <nb-form-field class="form-field">
            <label>{{'password_old'| translation}}</label>
            <input #oldPassword="ngModel" [(ngModel)]="oldPw" nbInput [placeholder]="'password_old'| translation"  type="password" required>
          </nb-form-field>
          <nb-form-field class="form-field">
            <label>{{'password_new'| translation}}</label>
            <input #newPassword="ngModel" [(ngModel)]="newPw" nbInput [placeholder]="'password_new'| translation" type="password"
                   required
                   [minlength]="policies.MinimumLength"
                   [mustHaveUpercase]="policies.RequireUppercase"
                   [mustHaveLowercase]="policies.RequireLowercase"
                   [mustHaveNumber]="policies.RequireNumbers"
                   mustContainCharacters="{{ policies.RequireSymbols ? COGNITO_SPECAIL_CHARACTER_REGEX : null}}">
          </nb-form-field>
          <nb-form-field class="form-field">
            <label>{{'password_confirm'| translation}}</label>
            <input #confirmPassword="ngModel" [(ngModel)]="confirmPw" nbInput [placeholder]="'password_confirm'| translation" type="password" required mustMatchInput="{{newPw}}">
          </nb-form-field>
          <password-strength-meter (strengthChange)="passwordStrength=$event" [minPasswordLength]="3" [enableFeedback]="true" [password]="newPw"></password-strength-meter>

          <div class="flex-list" style="margin-top:40px;">
            <button nbButton status="basic" (click)=location.back()>{{'cancel'| translation}}</button>
            <button nbButton status="primary" (click)=resetPw() [disabled]="oldPassword.invalid || newPassword.invalid || confirmPassword.invalid">{{'reset'| translation}}</button>
          </div>
        </div>
        <ng-template #loading>
          <div class="reset-password-loading-container">
            <i class="fas fa-spinner fa-spin" ></i>
          </div>
        </ng-template>
      </nb-card-body>
    </nb-card>
  </div>
</div>
